import {Name} from "./Name";
import {Address} from "./Address";
import {PhoneNumber} from "./PhoneNumber";

export class Customer
{
	id = "";
	emailAddress = "";
	firstName = "";
	middleName = "";
	lastName = "";
	companyName = "";
	addresses: Array<Address> = [];
	phoneNumbers: Array<PhoneNumber> = [];
	metadata: { [prop: string]: string } = {};
}


// WEBPACK FOOTER //
// ./src/models/Customer.ts